import React from 'react'
import { FormLabel, Stack } from '@mui/material'
import TextColorFontBody from 'common/Typography/TextColorFontBody'

interface FormProps {
  formLabelHeader: string
  formContent: string | number
}

function FormDetailsStack(props: FormProps) {
  const { formLabelHeader, formContent } = props
  return (
    <Stack>
      <FormLabel className='formSmallLabel'>{formLabelHeader}</FormLabel>
      <TextColorFontBody>{formContent}</TextColorFontBody>
    </Stack>
  )
}

export default FormDetailsStack
